import type { Answer } from "types/answer";
import type { Question } from "types/question";
import type { ProfileClinical } from "types/profile";
import { findAnswerByQuestionTag } from "utils/questions";
import {
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2,
  HAS_DIABETES,
  HAS_GLP1
} from "config/tags";
import { CLINICAL_PROGRAM, CORE_PRODUCT, DIABETES_PROGRAM, DIABETES_WORKSHOP_PROGRAM, GLP1_PROGRAM, GLP1_WORKSHOP_PROGRAM, NOT_ELIGIBLE, PREMIUM_PRODUCT } from "./constants";
import { fetchWaitlistReason, submitDataToDb } from "utils/assessment";

export const getResultsUniV5 = async (
  answers: Answer[],
  questions: Question[],
  profile: ProfileClinical,
  dbSlugs: string[]
): Promise<{ sequenceEligible: boolean; result: string }> => {
  // Clinical branch.
  if (profile?.medical?.dob) {
    const id = await submitDataToDb(answers, questions, dbSlugs);
    const waitlistReason = await fetchWaitlistReason(id, `${!profile?.isB2B}`);

    if (waitlistReason) {
      return {
        sequenceEligible: false,
        result: waitlistReason
      };
    }

    return {
      sequenceEligible: true,
      result: CLINICAL_PROGRAM
    };
  }

  const gs1 = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION1,
    answers,
    questions
  );
  const gs2 = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION2,
    answers,
    questions
  );
  const hasGlp1Answer = findAnswerByQuestionTag(
    HAS_GLP1,
    answers,
    questions
  );
  const hasDiabetesAnswer = findAnswerByQuestionTag(
    HAS_DIABETES,
    answers,
    questions,
  );

  if (!gs1 || !gs2) {
    return {
      sequenceEligible: false,
      result: NOT_ELIGIBLE,
    };
  }

  const gsAnswers = `${gs1},${gs2}`;
  switch (gsAnswers) {
    case "D,W":
    case "V,W":
    case "W,V":
    case "W,W":
      if (hasGlp1Answer === "Yes") {
        return {
          sequenceEligible: false,
          result: GLP1_WORKSHOP_PROGRAM
        };
      }
      if (hasDiabetesAnswer === "Yes") {
        return {
          sequenceEligible: false,
          result: DIABETES_WORKSHOP_PROGRAM
        };
      }
      return {
        sequenceEligible: false,
        result: PREMIUM_PRODUCT
      };
    default:
      if (hasGlp1Answer === "Yes") {
        return {
          sequenceEligible: false,
          result: GLP1_PROGRAM
        };
      }
      if (hasDiabetesAnswer === "Yes") {
        return {
          sequenceEligible: false,
          result: DIABETES_PROGRAM
        };
      }
      return {
        sequenceEligible: false,
        result: CORE_PRODUCT
      };
  }
};
